import { jwtDecode } from 'jwt-decode'

import { HandleAuthCredentialsFn, UserObj } from 'api/actions/auth/authActions.types'
import { LocalStorageKey } from 'containers/Auth/auth.types'

export const handleAuthCredentials: HandleAuthCredentialsFn = (response, trustedDevice) => {
    const { access_token, refresh_token, backup_codes } = response

    const user = jwtDecode(access_token) as UserObj

    const responseObject = {
        access_token,
        refresh_token,
        user,
        backupCodes: backup_codes,
    }

    const deviceId = user['2fa_device_id']

    if (access_token && refresh_token) {
        localStorage.setItem('auth_access_token', access_token)
        localStorage.setItem('auth_refresh_token', refresh_token)
    }

    if (typeof deviceId === 'string' && trustedDevice === true) {
        if (user?.username) {
            localStorage.setItem(`${LocalStorageKey.MfaDeviceId}${user.username}`, deviceId)
        }
        if (user?.email) {
            localStorage.setItem(`${LocalStorageKey.MfaDeviceId}${user.email}`, deviceId)
        }
    }

    return responseObject
}

export const removeLocalstorageKeys = (mfaDeviceId: string): void => {
    Object.keys(localStorage).forEach((key) => {
        if (localStorage.getItem(key) === mfaDeviceId) {
            localStorage.removeItem(key)
        }
    })
}
